import { render } from "./Invest.vue?vue&type=template&id=1c14b36b"
import script from "./Invest.vue?vue&type=script&lang=js"
export * from "./Invest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__